import { ApplicationRef, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
// Core providers
import {
  AuthModule,
  ChartJsModule,
  ConnectivityCheckModule,
  CoreModule,
  I18nModule,
  I18nPipe,
  LoadingIconModule,
  MoneyFormatPipe,
  PanelServiceSelectorModule,
  SharedAngularComponentsAvlaModule,
  SmartadminModule,
} from 'shared-angular-components-avla';
import { CountryModule } from 'shared-angular-components-avla/country/country.module';

/*
 * Platform and Environment providers/directives/pipes
 */
import { routing } from './app.routing';
// App is our top level component
import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import { RetryNotificationMessageService } from 'base-angular-avla/services/retry-notification.message.service';
import { AppComponent } from './app.component';
import { APP_RESOLVER_PROVIDERS } from './app.resolver';
import { AppState, InternalStateType } from './app.service';
import { DevModule } from './development-environment/dev.module';
import { HelpModule } from './help-component/help.module';
import { ValidatorService } from './validator.service';

import { CargaArchivoModule } from './carga-archivo/carga-archivo.module';
import { CargaArchivoService } from './carga-archivo/service/carga-archivo.service';
import { ConsultaMarkListModule } from './consulta-mark-list/consulta-mark-list.module';
import { ConsultaMarkListService } from './consulta-mark-list/service/consulta-mark-list.service';
import { ListArchivosModule } from './list-archivos/list-archivos.module';
import { ListArchivosService } from './list-archivos/service/list-archivos.service';

import localeEn from '@angular/common/locales/en';
import localeEsCl from '@angular/common/locales/es-CL';
import localeEsMx from '@angular/common/locales/es-MX';
import localeEsPe from '@angular/common/locales/es-PE';
import { CustomLoaderModule } from '@shared/components/custom-loader/custom-loader.module';
import {
  NotificationRequestService,
  NotificationService,
  PanelCountrySelectorModule,
} from 'amaru-web-components';
import { BaseAngularAvlaModule } from 'base-angular-avla';
import { CommonService } from 'services-sc-component';
import { CountrySelectionModule } from './components/country-selection/country-selection.module';

registerLocaleData(localeEsCl, 'es-CL');
registerLocaleData(localeEsPe, 'es-PE');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeEsMx, 'es-MX');

// Application wide providers
const APP_PROVIDERS = [...APP_RESOLVER_PROVIDERS, AppState];

type StoreType = {
  state: InternalStateType;
  restoreInputValues: () => void;
  disposeOldHosts: () => void;
};

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [AppComponent],
  declarations: [AppComponent],
  imports: [
    // import Angular's modules
    ChartJsModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    CoreModule,
    I18nModule,
    SmartadminModule,
    CommonModule,
    SharedAngularComponentsAvlaModule.forRoot(),
    LoadingIconModule,
    HelpModule,
    DevModule,
    CountryModule.forRoot('MARKLIST', '-', null),
    BaseAngularAvlaModule.forRoot(),
    CountrySelectionModule,
    AuthModule.forRoot(false),
    PanelServiceSelectorModule,
    ConnectivityCheckModule,
    ConsultaMarkListModule,
    CargaArchivoModule,
    ListArchivosModule,
    routing,
    PanelCountrySelectorModule,
    CustomLoaderModule,
    //CommonsGenericTableAvlaModule,
  ],
  exports: [],
  providers: [
    // expose our Services and Providers into Angular's dependency injection
    // ENV_PROVIDERS,
    APP_PROVIDERS,
    ValidatorService,
    DatePipe,
    MoneyFormatPipe,
    RetryNotificationMessageService,
    ConsultaMarkListService,
    CargaArchivoService,
    ListArchivosService,
    CommonService,
    I18nPipe,
    NotificationRequestService,
    NotificationService,
  ],
})
export class AppModule {
  constructor(public appRef: ApplicationRef, public appState: AppState) {}
}
